<script setup>
import { useStoreStore } from "@stores/store";
import { computed } from "vue";

import Button from "@components/global/button.vue";

const store = useStoreStore();
const props = defineProps(["product"]);

const plusButtonDisabled = computed(() => props.product.quantity >= 10);
const minusButtonDisabled = computed(() => props.product.quantity <= 1);

function changeQuantity(delta) {
  let quantity = props.product.quantity + delta;
  if (quantity > 0 && quantity <= 10) {
    store.updateCart({
      id: props.product.id,
      quantity: quantity,
    });
  }
}
function remove() {
  store.updateCart({
    id: props.product.id,
    quantity: 0,
  });
}
</script>

<template>
  <div
    class="flex items-center gap-6 border-t border-border pt-5 font-semibold text-sm first:border-none first:pt-0">
    <div class="bg-border-default h-24 w-24 rounded-big bg-bgSecondary p-2">
      <img
        class="h-full w-full object-contain"
        :src="product.image"
        :alt="product.title" />
    </div>
    <div class="flex grow flex-col gap-3">
      <div class="flex items-center justify-between gap-2">
        <div class="flex flex-col gap-1">
          <div class="flex flex-col">
            <p class="text-sm text-primaryLight">{{ product.type }}</p>
            <p class="text-base text-primary">
              {{ product.title }}
            </p>
          </div>
        </div>
        <Button
          class="remove"
          :without-edge="true"
          @click="remove"
          icon="fa-regular fa-trash-can text-redBase">
        </Button>
      </div>
      <div class="flex items-center justify-between">
        <div
          class="flex w-fit items-stretch rounded-full border border-border bg-bgMain px-1">
          <Button
            class="disabled:text-primaryDisabled flex h-8 w-8 items-center justify-center duration-500"
            :disabled="minusButtonDisabled"
            @click="changeQuantity(-1)"
            icon="fa-solid fa-minus">
          </Button>
          <div class="flex items-center px-5">
            <span>{{ product.quantity }}</span>
          </div>
          <Button
            class="disabled:text-primaryDisabled flex h-8 w-8 items-center justify-center text-primary transition-colors duration-500"
            :disabled="plusButtonDisabled"
            @click="changeQuantity(+1)"
            icon="fa-solid fa-plus">
          </Button>
        </div>
        <p class="font-bold text-base">{{ product.price }}</p>
      </div>
    </div>
  </div>
</template>


